<template>
  <client-only>
    <span :data-t-id="translateKey" class="group relative">
      <span v-html="$t(props.translateKey, props.translateOptions)" />

      <span class="hidden group-hover:inline absolute">
        <Edit
          class="el-icon-edit text-white px-1 py-1 bg-blue-500 mt-1 ml-1 w-6 h-6 rounded-lg hover:cursor-pointer"
          :title="'Translate (edit) ' + translateKey"
          @click="openWeblate($event, translateKey)"
        />
      </span>
    </span>
  </client-only>
</template>
<script setup>
import { Edit } from "@element-plus/icons-vue";
const { locale } = useI18n();
const config = useRuntimeConfig();

const props = defineProps({
  translateKey: {
    type: String,
    required: true,
  },
  translateOptions: {
    type: Object,
    required: false,
    default: () => ({}),
  },
});

const openWeblate = ($e, phrase) => {
  $e.preventDefault();
  window.open(
    `${config.public.translateUrl}translate/gfsgroup/frontend/${locale.value}/?q=${phrase}`,
    "_blank",
  );
};
</script>
